import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum MedicineAdherenceStatus {
    NON_ADHERENT = 'NON_ADHERENT',
    POOR_PARTIALLY_ADHERENT = 'POOR_PARTIALLY_ADHERENT',
    ADHERENT = 'ADHERENT'
}



@Pipe({
    name: 'adherenceLabel',
    pure: false // in case language changes dynamically
})
export class AdherenceLabelPipe implements PipeTransform {

    constructor(private translate: TranslateService) { }

    transform(percentage: number): string {
        let status: MedicineAdherenceStatus;

        if (percentage >= 86) {
            status = MedicineAdherenceStatus.ADHERENT;
        } else if (percentage >= 41) {
            status = MedicineAdherenceStatus.POOR_PARTIALLY_ADHERENT;
        } else {
            status = MedicineAdherenceStatus.NON_ADHERENT;
        }

        const label = this.translate.instant(`${status}`);

        return `${label}`;
    }
}

